// Sidebar del módulo Mantenimiento como MUNDO PROPIO — para el personal
// DEDICADO a mantenimiento (rol de plataforma 'lider' + rol de módulo en
// usuarios_mantenimiento, decisión de producto 2026-07-05): ese usuario no ve
// los mundos de producción, su navegación entera es el módulo.
//
// Mismos primitivos que el resto de sidebars (SidebarNav) + wordmark al pie
// (patrón DirectivoSidebar) para que se sienta un mundo más de la app.

import { Sidebar, SidebarGroup, SidebarItem } from './SidebarNav';
import { usePermisosMtto } from '../../features/mantenimiento/shared';
import { useParosPendientesMtto } from '../../features/mantenimiento/queries';
import { useAuth } from '../../lib/auth';

export function MantenimientoSidebar() {
  const { state } = useAuth();
  const { puedeGestionarPersonal, puedeVerAnalisis } = usePermisosMtto();
  // Badge de la cola de validación (misma query que la pantalla — se cachea).
  const pendientes = useParosPendientesMtto({});
  const pendientesCount = pendientes.data?.conteos.pendientes ?? 0;
  const tenantNombre =
    state.kind === 'signed_in'
      ? (state.claims.tenants_disponibles.find((t) => t.id === state.claims.tenant_id_activo)
          ?.nombre ?? '')
      : '';

  return (
    <Sidebar>
      <SidebarGroup label="Mantenimiento">
        <SidebarItem to="/mantenimiento" end icon="gauge">
          Panel
        </SidebarItem>
        <SidebarItem
          to="/mantenimiento/lineas"
          icon="factory"
          badge={pendientesCount > 0 ? String(pendientesCount) : undefined}
          badgeTone="warn"
        >
          Líneas y paros
        </SidebarItem>
        {puedeVerAnalisis ? (
          <SidebarItem to="/mantenimiento/paros" icon="alert">
            Análisis de paros
          </SidebarItem>
        ) : null}
        <SidebarItem to="/mantenimiento/ordenes" icon="wrench">
          Órdenes de trabajo
        </SidebarItem>
        <SidebarItem to="/mantenimiento/activos" icon="sitemap">
          Activos
        </SidebarItem>
        <SidebarItem to="/mantenimiento/repuestos" icon="settings">
          Repuestos
        </SidebarItem>
        <SidebarItem to="/mantenimiento/programacion" icon="calendar">
          Programación
        </SidebarItem>
        {puedeGestionarPersonal ? (
          <SidebarItem to="/mantenimiento/personal" icon="users">
            Personal
          </SidebarItem>
        ) : null}
        {puedeVerAnalisis ? (
          <SidebarItem to="/mantenimiento/informes" icon="chart-bar">
            Informes
          </SidebarItem>
        ) : null}
      </SidebarGroup>
      <div className="mt-auto px-3 pb-1 pt-4">
        <p className="truncate font-mono text-[10px] tracking-[0.06em] text-fg-tertiary">
          Jidokap{tenantNombre ? ` · ${tenantNombre}` : ''}
        </p>
      </div>
    </Sidebar>
  );
}
